import { LANDING_AMPLITUDE_EVENTS, LOCAL_STORAGE_KEYS } from '@/constants';
import benefit from '@/public/images/ai-image-editor/benefits.webp';
import hero from '@/public/images/ai-image-editor/hero.webp';
import howWork from '@/public/images/ai-image-editor/howItWorks.webp';
import whyLift from '@/public/images/ai-image-editor/WhyLift.webp';
import bgRemoverCard from '@/public/images/landing/slider/AI_Background_Remover.webp';
import filtersCard from '@/public/images/landing/slider/AI_Cartoon_Generator.webp';
import clothesChangerCard from '@/public/images/landing/slider/AI_Clothes_Changer.webp';
import hairstyleCard from '@/public/images/landing/slider/AI_Hairstyle_Changer.webp';
import headshotCard from '@/public/images/landing/slider/AI_headshot_generator.webp';
import enhancerCard from '@/public/images/landing/slider/AI_Image_Enhancer.webp';
import imageExtenderCard from '@/public/images/landing/slider/AI_Image_Extender.webp';
import upscalerCard from '@/public/images/landing/slider/AI_Image_Upscaler.webp';
import objectRemoverCard from '@/public/images/landing/slider/AI_Magic_Eraser.webp';
import watermarkCard from '@/public/images/landing/slider/AI_Watermark_remover.webp';
import photoColorizerCard from '@/public/images/landing/slider/Photo_Colorizer.webp';
import { type LandingConfigItem } from '../../types';
import { exploreConfig } from './exploreConfig';
import { tryLiftConfig } from './tryLiftConfig';

const HERO_DATA_IMAGE_TITLE =
	'AI photo editor with easy-to-use editing controls';
const HERO_DATA_IMAGE_ALT = 'AI photo editor with easy-to-use editing controls';
const HOW_IT_WORK_DATA_IMAGE_TITLE =
	'Cut photo out of background & Erase object from image';
const HOW_IT_WORK_DATA_IMAGE_ALT =
	'Cut photo out of background & Erase object from image';
const BENEFITS_IMAGE_TITLE = 'Photo enhancer & Image upscaler';
const BENEFITS_IMAGE_ALT = 'Photo enhancer & Image upscaler';
const WHY_TITLE_IMAGE_TITLE =
	'AI filters for photos: Muppet, Simpsons, Minecraft';
const WHY_TITLE_IMAGE_ALT =
	'AI filters for photos: Muppet, Simpsons, Minecraft';

export const landingAiImageEditorConfig: LandingConfigItem = {
	id: 'ai-image-editor',
	translationLocale: 'ai-image-editor',
	withDropZone: false,
	hideToolsWidget: true,
	toolsGrid: {
		locale: 'ai-image-editor',
		hideBackground: true,
		hero: {
			title: 'toolsGrid_title',
			buttonText1: '',
			buttonText2: '',
			buttonText3: '',
			list: [
				{
					id: 11,
					image: imageExtenderCard,
					title: 'toolsGrid_cards_card1',
					alt: 'toolsGrid_cards_card1Alt',
					href: '/image-extender',
				},
				{
					id: 10,
					image: watermarkCard,
					title: 'toolsGrid_cards_card2',
					alt: 'toolsGrid_cards_card2Alt',
					href: '/watermark-remover',
				},
				{
					id: 9,
					image: headshotCard,
					title: 'toolsGrid_cards_card3',
					alt: 'toolsGrid_cards_card3Alt',
					href: '/headshot-generator',
				},
				{
					id: 8,
					image: objectRemoverCard,
					title: 'toolsGrid_cards_card4',
					alt: 'toolsGrid_cards_card4Alt',
					href: '/object-remover',
				},
				{
					id: 7,
					image: bgRemoverCard,
					title: 'toolsGrid_cards_card5',
					alt: 'toolsGrid_cards_card5Alt',
					href: '/background-remover',
				},
				{
					id: 6,
					image: enhancerCard,
					title: 'toolsGrid_cards_card6',
					alt: 'toolsGrid_cards_card6Alt',
					href: '/image-enhancer',
				},
				{
					id: 5,
					image: upscalerCard,
					title: 'toolsGrid_cards_card7',
					alt: 'toolsGrid_cards_card7Alt',
					href: '/image-upscaler',
				},
				{
					id: 4,
					image: filtersCard,
					title: 'toolsGrid_cards_card8',
					alt: 'toolsGrid_cards_card8Alt',
					href: '/ai-filters',
				},
				{
					id: 3,
					image: photoColorizerCard,
					title: 'toolsGrid_cards_card9',
					alt: 'toolsGrid_cards_card9Alt',
					href: '/photo-colorizer',
				},
				{
					id: 2,
					image: clothesChangerCard,
					title: 'toolsGrid_cards_card10',
					alt: 'toolsGrid_cards_card10Alt',
					href: '/clothes-changer',
				},
				{
					id: 1,
					image: hairstyleCard,
					title: 'toolsGrid_cards_card11',
					alt: 'toolsGrid_cards_card11Alt',
					href: '/hairstyle-changer',
				},
			],
		},
	},
	hero: {
		type: 'noDropzone',
		title: 'heroData_title',
		description: 'heroData_subtitle',
		buttonText: 'heroData_buttonText',
		background: true,
		images: [
			{
				image: hero,
				title: HERO_DATA_IMAGE_TITLE,
				alt: HERO_DATA_IMAGE_ALT,
			},
		],
	},
	howItWork: {
		title: 'howItWorkData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🖼',
				title: 'howItWorkData_title1',
				subtitle: 'howItWorkData_subtitle1',
			},
			{
				icon: '✨',
				title: 'howItWorkData_title2',
				subtitle: 'howItWorkData_subtitle2',
			},
			{
				icon: '💁‍♀️',
				title: 'howItWorkData_title3',
				subtitle: 'howItWorkData_subtitle3',
			},
			{
				icon: '🤘',
				title: 'howItWorkData_title4',
				subtitle: 'howItWorkData_subtitle4',
			},
		],
		images: [
			{
				image: howWork,
				title: HOW_IT_WORK_DATA_IMAGE_TITLE,
				alt: HOW_IT_WORK_DATA_IMAGE_ALT,
			},
		],
	},
	benefits: {
		title: 'benefitData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle1',
			},
			{
				icon: '🔹',
				title: '',
				subtitle: 'benefitData_subtitle2',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle3',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle4',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle5',
			},
		],
		images: [
			{
				image: benefit,
				title: BENEFITS_IMAGE_TITLE,
				alt: BENEFITS_IMAGE_ALT,
			},
		],
	},
	faq: {
		title: 'faqData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				title: 'faqData_title1',
				subtitle: 'faqData_subtitle1',
			},
			{
				title: 'faqData_title2',
				subtitle: 'faqData_subtitle2',
			},
			{
				title: 'faqData_title3',
				subtitle: 'faqData_subtitle3',
			},
			{
				title: 'faqData_title4',
				subtitle: 'faqData_subtitle4',
			},
		],
	},
	whyLift: {
		title: 'whyUseData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '✅',
				title: 'whyUseData_title1',
				subtitle: 'whyUseData_subtitle1',
			},
			{
				icon: '✅',
				title: 'whyUseData_title2',
				subtitle: 'whyUseData_subtitle2',
			},
			{
				icon: '✅',
				title: 'whyUseData_title3',
				subtitle: 'whyUseData_subtitle3',
			},
			{
				icon: '✅',
				title: 'whyUseData_title4',
				subtitle: 'whyUseData_subtitle4',
			},
		],
		images: [
			{
				image: whyLift,
				title: WHY_TITLE_IMAGE_TITLE,
				alt: WHY_TITLE_IMAGE_ALT,
			},
		],
	},
	explore: {
		...exploreConfig,
	},
	tryLift: {
		...tryLiftConfig,
	},
	analytics: {
		scrolledPercentName: LOCAL_STORAGE_KEYS.AI_IMAGE_EDITOR_SCROLLED_POINTS,
		eventPropertyType: LANDING_AMPLITUDE_EVENTS.AI_IMAGE_EDITOR,
		galleryContext: LANDING_AMPLITUDE_EVENTS.AI_IMAGE_EDITOR_LANDING,
	},
};
